import { genericFieldValidation } from '../../utils/form-validation/form-validation';

export const getFormDataErrors = ({ name, email, question }) => {
  return {
    name: genericFieldValidation(name),
    email: genericFieldValidation(email),
    question: genericFieldValidation(question)
  };
};

export const getOnLoginFailureErrors = ({ response }) => {
  const newErrors = {
    name: null,
    email: null,
    question: null
  };

  if (!response || !response.data || !response.data.error) {
    return newErrors;
  }

  const { error } = response.data;

  if (error.name) {
    newErrors.name = error.name;
  }

  if (error.email) {
    newErrors.email = error.email;
  }

  if (error.question) {
    newErrors.question = error.question;
  }

  return newErrors;
};
